import { render, staticRenderFns } from "./Template27.vue?vue&type=template&id=305875d4&scoped=true&"
import script from "./Template27.vue?vue&type=script&lang=js&"
export * from "./Template27.vue?vue&type=script&lang=js&"
import style0 from "./Template27.vue?vue&type=style&index=0&id=305875d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305875d4",
  null
  
)

export default component.exports